import routes from 'src/routes'

const getRoute = (to) => {
  // if it is and we're using routes, use the defined routes
  if (!routes[to]) {
    throw Error(`Route '${to}' does not exist`)
  }

  return routes[to]
}

export default getRoute
